import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      meta: {
        'title': '使用说明'
      },
      name: 'Home',
      component: () => import('@/components/Home')
    },
    {
      path: '/login',
      meta: {
        'title': '登录'
      },
      name: 'Login',
      component: () => import('@/components/Common/Login')
    },
    {
      path: '/menu/list',
      meta: {
        'title': '菜单管理'
      },
      name: 'MenuList',
      component: () => import('@/components/Menu/List')
    },
    {
      path: '/group/list',
      meta: {
        'title': '权限管理'
      },
      name: 'GroupList',
      component: () => import('@/components/Group/List')
    },
    {
      path: '/edit-password',
      meta: {
        'title': '修改密码'
      },
      name: 'EditPassword',
      component: () => import('@/components/Manager/EditPassword')
    },
    {
      path: '/manager/list',
      meta: {
        'title': '管理员管理'
      },
      name: 'ManagerList',
      component: () => import('@/components/Manager/List')
    },
    {
      path: '/setting/list',
      meta: {
        'title': '参数配置'
      },
      name: 'SettingList',
      component: () => import('@/components/Setting/List')
    },
    {
      path: '/setting-refund',
      meta: {
        'title': '退款信息配置'
      },
      name: 'SettingRefund',
      component: () => import('@/components/Setting/Refund')
    },
    {
      path: '/banner/list',
      meta: {
        'title': '广告位管理'
      },
      name: 'BannerList',
      component: () => import('@/components/Banner/List')
    },{
      path: '/charge/list',
      meta: {
        'title': '充值设置'
      },
      name: 'ChargeList',
      component: () => import('@/components/Charge/List')
    },{
      path: '/intro/list',
      meta: {
        'title': '内容管理'
      },
      name: 'IntroList',
      component: () => import('@/components/Intro/List')
    },
    {
      path: '/car/list',
      meta: {
        'title': '车辆管理'
      },
      name: 'CarList',
      component: () => import('@/components/Car/List')
    },
    {
      path: '/driver/list',
      meta: {
        'title': '司机管理'
      },
      name: 'DriverList',
      component: () => import('@/components/Driver/List')
    },
    {
      path: '/feedback/list',
      meta: {
        'title': '投诉反馈'
      },
      name: 'FeedbackList',
      component: () => import('@/components/Feedback/List')
    },
    {
      path: '/notice/list',
      meta: {
        'title': '通知公告'
      },
      name: 'NoticeList',
      component: () => import('@/components/Notice/List')
    },
    {
      path: '/content/list',
      meta: {
        'title': '帮助中心'
      },
      name: 'ContentList',
      component: () => import('@/components/Content/List')
    },
    {
      path: '/block/list',
      meta: {
        'title': '首页模块管理'
      },
      name: 'BlockList',
      component: () => import('@/components/Block/List')
    },
    {
      path: '/member/list',
      meta: {
        'title': '会员列表'
      },
      name: 'MemberList',
      component: () => import('@/components/Member/List')
    },
    {
      path: '/member/visit-list',
      meta: {
        'title': '用户回访'
      },
      name: 'MemberVisitList',
      component: () => import('@/components/Member/VisitList')
    },{
      path: '/coupon/list',
      meta: {
        'title': '优惠券列表'
      },
      name: 'CouponList',
      component: () => import('@/components/Coupon/List')
    },
    {
      path: '/balance/list',
      meta: {
        'title': '充值记录'
      },
      name: 'BalanceList',
      component: () => import('@/components/Balance/List')
    },
    {
      path: '/isp/list',
      meta: {
        'title': '服务商列表'
      },
      name: 'IspList',
      component: () => import('@/components/Isp/List')
    },
    {
      path: '/business/list',
      meta: {
        'title': '商家列表'
      },
      name: 'BusinessList',
      component: () => import('@/components/Business/List')
    },
    {
      path: '/business/:id/isp',
      meta: {
        'title': '商家服务商'
      },
      name: 'BusinessIsp',
      component: () => import('@/components/Business/Isp')
    },
    {
      path: '/regular-bus/list',
      meta: {
        'title': '班车列表'
      },
      name: 'RbList',
      component: () => import('@/components/RegularBus/List')
    },
    {
      path: '/charter-bus/list',
      meta: {
        'title': '包车列表'
      },
      name: 'CbList',
      component: () => import('@/components/CharterBus/List')
    },
    {
      path: '/station/list',
      meta: {
        'title': '站点列表'
      },
      name: 'StationList',
      component: () => import('@/components/Station/List')
    },
    {
      path: '/busline/list',
      meta: {
        'title': '线路列表'
      },
      name: 'BuslineList',
      component: () => import('@/components/Busline/List')
    },
    {
      path: '/busline/:id/station',
      meta: {
        'title': '线路站点'
      },
      name: 'BuslineStation',
      component: () => import('@/components/Busline/Station')
    },
    {
      path: '/busline-class/list',
      meta: {
        'title': '班次列表'
      },
      name: 'BuslineClassList',
      component: () => import('@/components/BuslineClass/List')
    },
    {
      path: '/order/busline-list',
      meta: {
        'title': '车票订单列表'
      },
      name: 'OrderBuslineList',
      component: () => import('@/components/Order/BuslineList')
    },
    {
      path: '/order/ticket-list',
      meta: {
        'title': '车票管理'
      },
      name: 'OrderTicketList',
      component: () => import('@/components/Order/TicketList')
    },
    {
      path: '/sms/list',
      meta: {
        'title': '历史短信'
      },
      name: 'SmsList',
      component: () => import('@/components/Sms/List')
    },
    {
      path: '/booking/list',
      meta: {
        'title': '预约记录'
      },
      name: 'BookingList',
      component: () => import('@/components/Booking/List')
    },
    {
      path: '/refund/list',
      meta: {
        'title': '退票改签'
      },
      name: 'RefundList',
      component: () => import('@/components/refund/List')
    },
    {
      path: '/log/list',
      meta: {
        'title': '余额日志'
      },
      name: 'LogBalanceList',
      component: () => import('@/components/Log/List')
    },
    {
      path: '/black/list',
      meta: {
        'title': '黑名单'
      },
      name: 'BlackList',
      component: () => import('@/components/Black/List')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js